(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["koji-delivery-box"] && !Shopify.designMode) return;
  try {
    (function () {
    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function deadlineFor(root, now) {
      const mode = (root.getAttribute('data-koji-mode') || 'midnight').trim();
      if (mode === 'cycle') {
        const hours = parseInt(root.getAttribute('data-koji-cycle-hours'), 10) || 8;
        const cycleMs = hours * 3600 * 1000;
        const dayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0).getTime();
        const elapsed = now.getTime() - dayStart;
        const next = Math.floor(elapsed / cycleMs) + 1;
        return dayStart + next * cycleMs;
      }
      const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0);
      return midnight.getTime();
    }

    function tick(root) {
      const now = new Date();
      const deadline = deadlineFor(root, now);
      let diff = Math.max(0, Math.floor((deadline - now.getTime()) / 1000));
      const h = Math.floor(diff / 3600);
      diff -= h * 3600;
      const m = Math.floor(diff / 60);
      const s = diff - m * 60;

      const hEl = root.querySelector('[data-koji-hours]');
      const mEl = root.querySelector('[data-koji-minutes]');
      const sEl = root.querySelector('[data-koji-seconds]');
      if (hEl) hEl.textContent = pad(h);
      if (mEl) mEl.textContent = pad(m);
      if (sEl) sEl.textContent = pad(s);
    }

    function init(root) {
      if (root.dataset.kojiInit === '1') return;
      root.dataset.kojiInit = '1';
      tick(root);
      setInterval(function () {
        tick(root);
      }, 1000);
    }

    function boot() {
      document.querySelectorAll('[data-koji-delivery]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["koji-packages"] && !Shopify.designMode) return;
  try {
    (function () {
    var roots = document.querySelectorAll('.koji-packages');
    roots.forEach(function (root) {
      if (root.dataset.kojiPackagesInit) return;
      root.dataset.kojiPackagesInit = '1';

      var deals = root.querySelector('[data-koji-deals]');
      if (!deals) return;
      var items = deals.querySelectorAll('.deal');

      var priceEl = root.querySelector('[data-koji-add-price]');

      function syncPrice() {
        if (!priceEl) return;
        var active = deals.querySelector('.deal.is-active');
        priceEl.textContent = active ? ('— ' + (active.getAttribute('data-price-label') || '')) : '';
      }

      function activate(d) {
        items.forEach(function (x) {
          x.classList.remove('is-active');
          var r = x.querySelector('.deal__row');
          if (r) r.setAttribute('aria-checked', x === d ? 'true' : 'false');
        });
        d.classList.add('is-active');
        syncPrice();
      }

      items.forEach(function (d) {
        d.addEventListener('click', function (e) {
          if (e.target.closest('.sw')) return;
          activate(d);
        });
        d.addEventListener('keydown', function (e) {
          if (e.target.closest('.sw')) return;
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); activate(d); }
        });
      });

      // wybór koloru — każdy wiersz niezależnie
      root.querySelectorAll('.swatches').forEach(function (rowEl) {
        var sws = rowEl.querySelectorAll('.sw');
        sws.forEach(function (s) {
          function pick() {
            sws.forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-checked', 'false'); });
            s.classList.add('is-active');
            s.setAttribute('aria-checked', 'true');
          }
          s.addEventListener('click', function (e) { e.stopPropagation(); pick(); });
          s.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); e.stopPropagation(); pick(); }
          });
        });
      });

      syncPrice();
      // Dodanie do koszyka (multi-line + cart drawer) obsługuje moduł koji-bundle-add.js
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["koji-rating"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('[data-koji-rating-jump]').forEach(function (el) {
      if (el.dataset.jumpInit) return;
      el.dataset.jumpInit = '1';
      el.addEventListener('click', function (e) {
        var t = document.getElementById(el.dataset.kojiRatingJump || 'recenze');
        if (!t) return;
        e.preventDefault();
        t.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["koji-sada-obsah"] && !Shopify.designMode) return;
  try {
    (function () {
  var SEL_RADIO = 'variant-picker input[type="radio"]';

  function znajdzRadio(nazwa) {
    var lista = document.querySelectorAll(SEL_RADIO);
    for (var i = 0; i < lista.length; i++) {
      if (lista[i].value === nazwa) return lista[i];
    }
    return null;
  }

  function odswiez(nazwa) {
    document.querySelectorAll('[data-sada-swatch]').forEach(function (el) {
      var on = el.getAttribute('data-sada-swatch') === nazwa;
      el.classList.toggle('is-active', on);
      el.setAttribute('aria-checked', on ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var sw = e.target.closest ? e.target.closest('[data-sada-swatch]') : null;
    if (!sw || sw.getAttribute('aria-disabled') === 'true') return;
    var nazwa = sw.getAttribute('data-sada-swatch');
    var radio = znajdzRadio(nazwa);
    if (radio && !radio.checked) {
      radio.click();
    }
    odswiez(nazwa);
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches(SEL_RADIO)) return;
    odswiez(t.value);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
